module.exports = {"430529100":"儒林镇","430529101":"茅坪镇","430529102":"西岩镇","430529103":"丹口镇","430529104":"五团镇","430529106":"长安营镇","430529107":"白毛坪镇","430529200":"威溪乡","430529203":"兰蓉乡","430529204":"汀坪乡","430529205":"蒋坊乡","430529206":"金紫乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430529.json
// module id = 1982
// module chunks = 0